import { ArrowUpRight, Globe2, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const platformLinks = [
  { label: 'Performance system', href: '/#performance' },
  { label: 'Progress proof', href: '/#targets' },
  { label: 'Intelligence layer', href: '/#architecture' },
  { label: 'Plans & pricing', to: '/pricing', type: 'route' },
  { label: 'Contact the team', href: '/#contact' },
];

const knowledgeLinks = [
  { label: 'Privacy policy', to: '/privacy', type: 'route' },
  { label: 'Terms of use', to: '/terms', type: 'route' },
  { label: 'main@tecniq.com.au', href: 'mailto:main@tecniq.com.au' },
  { label: 'Open in app', href: 'tecniq://auth-callback' },
];

function FooterColumn({ title, links }) {
  return (
    <div className="site-footer__column">
      <p className="spec-label site-footer__column-label">{title}</p>
      <ul className="site-footer__link-list">
        {links.map((link) => (
          <li key={link.label}>
            {link.type === 'route' ? (
              <Link to={link.to} className="site-footer__link">
                {link.label}
              </Link>
            ) : (
              <a href={link.href} className="site-footer__link">
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

function DefaultAside() {
  return (
    <div className="footer-dispatch ghost-outline">
      <p className="spec-label">Dispatch</p>
      <h3 className="footer-dispatch__title">Talk to TECNIQ</h3>
      <p className="footer-dispatch__body">
        For early access, support, partnerships, or product questions, reach us directly.
      </p>
      <a className="tk-button tk-button--primary tk-button--full" href="mailto:main@tecniq.com.au">
        Email the team
        <ArrowUpRight size={16} />
      </a>
    </div>
  );
}

export default function SiteFooter({ aside = null }) {
  const asideContent = aside || <DefaultAside />;

  return (
    <footer className="site-footer">
      <div className="site-container site-footer__grid">
        <div className="site-footer__brand-block">
          <Link to="/" className="site-footer__brand">
            TECNIQ
          </Link>
          <p className="site-footer__copy">
            A high-fidelity ecosystem for people who measure progress in years, not weeks.
            Designed for precision, built for consistency.
          </p>
          <div className="site-footer__utility-links" aria-label="TECNIQ utility links">
            <a className="site-footer__utility" href="https://tecniq.com.au">
              <Globe2 size={18} />
            </a>
            <a className="site-footer__utility" href="mailto:main@tecniq.com.au">
              <Mail size={18} />
            </a>
          </div>
        </div>

        <div className="site-footer__links-group">
          <FooterColumn title="Platform" links={platformLinks} />
          <FooterColumn title="Knowledge" links={knowledgeLinks} />
        </div>

        <div className="site-footer__aside">{asideContent}</div>
      </div>
    </footer>
  );
}
